module.exports = __webpack_public_path__ + "assets/rossette-star.93bc2325.svg";